import React, { useEffect } from "react";
import initBootstrapComponents from '../../utils/bootstrap';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import scooterIcon from '../../assets/img/icons/scooter.png';
import wheelchairIcon from '../../assets/img/icons/wheelchair.png';
import tileBackground from '../../assets/img/backgrounds/select-type-tile.png';

const ScooterBookingConfirmation = () => {

    useEffect(() => {
        initBootstrapComponents();
    }, []);

    const customerDetails = JSON.parse(localStorage.getItem('customerDetails'));
    const confirmation = JSON.parse(localStorage.getItem('scooterBookingConfirmation'));

    const formatDate = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const formatTime = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatEventDate = (start, end) => {
        if (!start) return '';
        const startStr = formatDate(start);
        if (!end) return startStr;
        const sameDay = new Date(start).toDateString() === new Date(end).toDateString();
        return sameDay ? startStr : `${startStr} – ${formatDate(end)}`;
    };

    const typeLabel = (type) => {
        if (!type) return 'Scooter';
        return type.charAt(0).toUpperCase() + type.slice(1);
    };

    const typeIcon = (type) => (type === 'wheelchair' ? wheelchairIcon : scooterIcon);

    const bookings = confirmation?.bookings || [];

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="bg-motability-mid-black-5 py-32 pt-lg-96 pb-lg-411" id="scooter-booking-confirmation">
                    <div className="container">
                        <h1 className="text-primary mb-4 mb-lg-5">
                            Booking confirmation
                        </h1>

                        <div className="bg-motability-white border border-motability-light-blue rounded-4 p-4 p-lg-32">
                            <div className="row row-gap-4 row-gap-lg-0 gx-xxl-5">
                                <div className="col-lg-6">
                                    <div className="bg-motability-mid-black-5 border border-motability-mid-black-2 rounded-4 p-4 p-lg-32">
                                        <h5 className="text-primary mb-1">
                                            {confirmation?.event_name}
                                        </h5>
                                        {confirmation?.event_start_at && (
                                            <p className="mb-3">
                                                {formatEventDate(confirmation.event_start_at, confirmation.event_end_at)}
                                            </p>
                                        )}

                                        <h6 className="text-primary mb-3">
                                            Your booking
                                        </h6>

                                        <div className="order-items">
                                            {bookings.map((booking) => (
                                                <div key={booking.booking_id} className="order-item d-flex align-items-start gap-3 py-3 border-bottom border-motability-mid-black-25">
                                                    <div
                                                        className="rounded-3 overflow-hidden d-flex align-items-center justify-content-center flex-shrink-0"
                                                        style={{
                                                            width: '90px',
                                                            height: '90px',
                                                            backgroundImage: `url(${tileBackground})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat'
                                                        }}
                                                    >
                                                        <img
                                                            src={typeIcon(booking.vehicle_type)}
                                                            alt=""
                                                            aria-hidden="true"
                                                            style={{ width: '60%', height: 'auto' }}
                                                        />
                                                    </div>

                                                    <div className="d-flex flex-column">
                                                        <p className="mb-0">
                                                            <span className="fw-semibold">Booking:</span> {typeLabel(booking.vehicle_type)}
                                                        </p>
                                                        <p className="mb-0">
                                                            <span className="fw-semibold">Booking date:</span> {formatDate(booking.booking_date)}
                                                        </p>
                                                        {booking.eta_at && (
                                                            <p className="mb-0">
                                                                <span className="fw-semibold">Estimated arrival time:</span> {formatTime(booking.eta_at)}
                                                            </p>
                                                        )}
                                                        <p className="mb-0">
                                                            <span className="fw-semibold">Booking ID:</span> {booking.booking_id}
                                                        </p>
                                                        <p className="mb-0">
                                                            <span className="fw-semibold">Participant Name:</span> {booking.participant_name}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <h6 className="text-primary mb-3 mt-4">
                                            Guest details
                                        </h6>
                                        <p className="fw-semibold mb-1">
                                            {customerDetails?.firstName} {customerDetails?.lastName}
                                        </p>
                                        <p className="mb-1">
                                            {customerDetails?.telephone}
                                        </p>
                                        <p className="mb-0">
                                            {customerDetails?.email}
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="content">
                                        <h5 className="text-motability-black mb-3">
                                            Next Steps
                                        </h5>

                                        <p>
                                            On the day, please arrive at least 10 minutes before your booking. Bring along your email confirmation and our staff will help you get your scooter.
                                        </p>
                                    </div>

                                    <div className="content mt-4">
                                        <h5 className="text-motability-black mb-3">
                                            Cancelling your booking
                                        </h5>

                                        <p>
                                            You can cancel your booking by clicking the link in your confirmation email.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default ScooterBookingConfirmation;
